export default "__VITE_ASSET__afedb172__"